import React, { Component } from 'react'
import { Left, Right } from './index'
import ViewPortUtil from '../../../helpers/ViewPortUtil'
import ScreenSizeHelper from '../../../helpers/ScreenSizeHelper'
import './style.sass'

class SplitView extends Component {

  componentDidMount() {
    if (this.props.withSideNav) {
      // make side nav scroll on different scenarios
      this.makeSideNavScrollable(this.props.bannerHeight)
    }
  }

  componentWillUnmount() {
    if (this.props.withSideNav) {
      window.removeEventListener('scroll', this.onScroll)
    }
  }

  makeSideNavScrollable(bannerHeight = 0) {
    /** 
     * using getElementById instead of refs because elements are in different components, 
     * hard to manage otherwise */
    const left = document.getElementById('split-view-left')
    const right = document.getElementById('split-view-right').firstChild
    const footer = document.getElementById('footer-id')
    // height of the screen (viewport)
    const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    // current header size of the app
    const header = 165 // actual size + positive pixels
    const minContentHeight = vh - (footer?.offsetHeight ? footer?.offsetHeight : 0) - header

    let nextLeftHeight = minContentHeight
    // default state
    if (right?.offsetHeight > minContentHeight) {
      nextLeftHeight = (vh - 75) - bannerHeight
      left.firstChild.style.maxHeight = `${nextLeftHeight}px`
    } else {
      left.firstChild.style.maxHeight = `${minContentHeight}px`
    }

    if (ScreenSizeHelper() === 'lg' || ScreenSizeHelper() === 'xl') {
      // when scrolling
      window.addEventListener('scroll', this.onScroll.bind(this, bannerHeight, left, right, vh, header, footer, minContentHeight, nextLeftHeight))
    }


    // scroll to selected element
    const leftRect = left?.firstChild?.getBoundingClientRect()
    const linkRect = document.getElementsByClassName('sidenav-active-link')[0]?.getBoundingClientRect()

    if (!linkRect || !leftRect) return

    // getting scroll height to selected link ((current_link_position - container_div_position) - container_height)
    const scrollTo = (linkRect.top - leftRect.top) - left?.firstChild?.offsetHeight
    // add positive pixels for scroller
    left.firstChild.scrollTop = scrollTo + 300
  }


  onScroll = (bannerHeight, left, right, vh, header, footer, minContentHeight, nextLeftHeight) => {
    // if no banner found scroll height trigger set to 20px
    let toFixedScroll = bannerHeight !== 0 ? 180 : 20
    // same logic as top navigation applies here as well.
    if (window.pageYOffset > toFixedScroll) {
      left.firstChild.style.position = 'fixed'
      left.firstChild.style.top = "125px"
      left.firstChild.style.maxHeight = `${(vh - header - ViewPortUtil.isVisibleInViewport(footer))}px`
      left.firstChild.style.width = `${left.offsetWidth - 30}px`
    }
    else {
      left.firstChild.style.position = 'relative'
      left.firstChild.style.top = "0"
      if (right.offsetHeight > minContentHeight) {
        left.firstChild.style.maxHeight = `${nextLeftHeight}px`
      }
    }
  }

  render() {
    return (
      <div className={`split-view-layout-container ${this.props.wrapperClassNames}`}>
        <div className={`${this.props.containerClassNames} container${this.props.isFluidContainer ? '-fluid': ''}`}>
          <div className="row">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }

}

SplitView.Left = Left
SplitView.Right = Right

export default SplitView